// src/tokens/duration.ts
var durationNormal = 200;
export { durationNormal };